"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Element = void 0;

var _react = _interopRequireDefault(require("react"));

var _genSpacingClassName = require("../genSpacingClassName");

var _genMarginClassName = require("../genMarginClassName");

var _Color = require("../Color");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* Use a base element to write all html tags, this will allow for use of react native or react web */
var bl = ["tag", "background", "span", "hide", "content", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight", "padding", "paddingTop", "paddingBottom", "paddingLeft", "paddingRight", "spacing", "spacingTop", "spacingBottom", "spacingLeft", "spacingRight", "width", "height", "borderColor", "borderWidth", "touchable", "link", "borderRadius"];

var expandBL = function expandBL(list) {
  var items = [];

  var _iterator = _createForOfIteratorHelper(list),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      items.push(item);
      items.push(item + "XS");
      items.push(item + "SM");
      items.push(item + "MD");
      items.push(item + "LG");
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return items;
};

var BlackList = expandBL(bl);
var VoidTags = ["input", "img", "textarea"];
/**
 * Element
 *
 * Base element used for everything, has helpers for spans, colors, margin, padding and more
 *
 * @component
 * @category Atoms
 */

var Element = function Element(props) {
  var tag = props.tag;
  var content = props.content;
  var children = props.children;
  var styles = props.style ? Object.assign({}, props.style) : {};
  var className = (0, _genSpacingClassName.genSpacingClassName)(props.className, props);
  className = (0, _genMarginClassName.genMarginClassName)(className, props);

  var onElementClick = function onElementClick(e) {
    if (props.onClick) {
      var el = e.target ? e.target : e.currentTarget;
      (0, _.trackEvent)({
        context: props.trkContext,
        action: props.trkAction,
        label: props.trkLabel,
        element: el
      });
      props.onClick(e);
    }
  }; // Spans


  if (props.span) {
    className += " span-".concat(props.span);
  }

  if (props.spanXS) {
    className += " span-".concat(props.spanXS, "-xs");
  }

  if (props.spanSM) {
    className += " span-".concat(props.spanSM, "-sm");
  }

  if (props.spanMD) {
    className += " span-".concat(props.spanMD, "-md");
  }

  if (props.spanLG) {
    className += " span-".concat(props.spanLG, "-lg");
  } // Hides


  if (props.hide) {
    className += " hide";
  }

  if (props.hideXS) {
    className += " hide-xs";
  }

  if (props.hideSM) {
    className += " hide-sm";
  }

  if (props.hideMD) {
    className += " hide-md";
  }

  if (props.hideLG) {
    className += " hide-lg";
  } // Background


  if (props.background) {
    if (/^#/gi.test(props.background)) {
      styles.background = props.background;
    } else {
      className += " bg-".concat(props.background);
    }
  } // Color


  if (props.color) {
    if (/^#/gi.test(props.color)) {
      styles.color = props.color;
    } else {
      className += " text-" + props.color;
    }
  } // Borders


  if (props.border) {
    className += " " + props.border;
  }

  if (props.borderTop) {
    className += " " + props.borderTop + "-top";
  }

  if (props.borderBottom) {
    className += " " + props.borderBottom + "-bottom";
  }

  if (props.borderLeft) {
    className += " " + props.borderLeft + "-left";
  }

  if (props.borderRight) {
    className += " " + props.borderRight + "-right";
  } // Touchable


  if (props.touchable) {
    className += " touchable";
  } // Style props


  if (props.width) {
    styles.width = props.width;
  }

  if (props.widthXS && window.innerWidth < 541) {
    styles.width = props.widthXS;
  }

  if (props.widthSM && window.innerWidth >= 541) {
    styles.width = props.widthSM;
  }

  if (props.widthMD && window.innerWidth >= 541 && window.innerHeight > 541) {
    styles.width = props.widthMD;
  }

  if (props.widthLG && window.innerWidth >= 1024) {
    styles.width = props.widthLG;
  }

  if (props.height) {
    styles.height = props.height;
  }

  if (props.heightXS && window.innerWidth < 541) {
    styles.width = props.widthXS;
  }

  if (props.heightSM && window.innerWidth >= 541) {
    styles.height = props.heightSM;
  }

  if (props.heightMD && window.innerWidth >= 540 && window.innerHeight > 540) {
    styles.height = props.heightMD;
  }

  if (props.heightLG && window.innerWidth >= 1024) {
    styles.height = props.heightLG;
  }

  if (props.borderRadius) {
    styles.borderRadius = props.borderRadius;
  }

  if (props.borderStyle) {
    styles.borderStyle = props.borderStyle;
  }

  if (props.borderWidth) {
    if (!styles.borderStyle) {
      styles.borderStyle = "solid";
    }

    styles.borderWidth = props.borderWidth;
  }

  if (props.borderColor) {
    if (!styles.borderStyle) {
      styles.borderStyle = "solid";
    }

    styles.borderColor = "var(--".concat(props.borderColor, ")");
  } // filters props


  var aProps = {};

  for (var key in props) {
    switch (key) {
      //// Tracking props
      case "trkContext":
        aProps["data-trk-ctx"] = props[key];
        break;

      case "trkAction":
        aProps["data-trk-act"] = props[key];
        break;

      case "trkLabel":
        aProps["data-trk-lbl"] = props[key];
        break;

      case "trk":
        aProps["data-trk"] = props[key];
        break;

      case "onClick":
        if (props.trkAction) {
          aProps["onClick"] = onElementClick;
          aProps["data-trk-ign"] = "true";
        } else {
          aProps["onClick"] = props[key];
        }

        break;
      //// other props

      default:
        if (props[key] && !BlackList.includes(key) && key !== content) {
          aProps[key] = props[key];
        }

        break;
    }
  }

  var attr = Object.assign({}, aProps, {
    className: className
  });

  if (Object.keys(styles).length > 0) {
    if (attr.style) {
      attr.style = Object.assign({}, attr.style, styles); //console.log('Element attr.styles merged', tag, attr.style)
    } else {
      attr.style = styles; //console.log('Element attr.styles props', tag, attr.style)
    }
  }

  if (attr.ref) {
    console.log("Element", tag, attr);
  }

  var Tag = tag ? tag : "div";

  if (VoidTags.includes(tag)) {
    if (tag === "input" && !attr.value) {
      attr.value = "";
    } // void elements no children


    return /*#__PURE__*/_react.default.createElement(Tag, attr);
  }

  if (props.link) {
    attr = _objectSpread(_objectSpread({}, attr), {}, {
      to: attr.href
    });
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, attr, content, children);
  }

  return /*#__PURE__*/_react.default.createElement(Tag, attr, content, children);
};

exports.Element = Element;
Element.Border = {
  Thin: "border-thin",
  Regular: "border-regular"
};
Element.Background = _Color.Color;
Element.propTypes = {
  /** Specify what type of html tag should be used. Example div, p, ul, ol, li ... */
  tag: _propTypes.default.string,

  /** boolean use the link tag */
  link: _propTypes.default.bool,

  /** The background color. One of Color.* */
  background: _propTypes.default.string,

  /** The foreground color. One of Color.* */
  color: _propTypes.default.oneOf(Object.keys(_Color.Color).map(function (k) {
    return _Color.Color[k];
  })),

  /** boolean true makes the cursor a pointer on hover */
  touchable: _propTypes.default.bool,

  /** Grid system height or width depending if this is in a row or column. Can be any number but general practice should be to use rows with a total width of span-12 */
  span: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** span value for mobile portrait */
  spanXS: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** span value for mobile landscape */
  spanSM: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** span value for tablets */
  spanMD: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** span value for desktops */
  spanLG: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** if true will hide this element */
  hide: _propTypes.default.bool,

  /** if true will hide this element on moble portrait */
  hideXS: _propTypes.default.bool,

  /** if true will hide this element on moble landscape */
  hideSM: _propTypes.default.bool,

  /** if true will hide this element on tablets */
  hideMD: _propTypes.default.bool,

  /** if true will hide this element on desktops */
  hideLG: _propTypes.default.bool,

  /** an alternative to children */
  content: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.element)]),

  /** css margins follows panenka values 1 => 4px */
  margin: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margins for XS devices, follows panenka values 1 => 4px */
  marginXS: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margins for SM devices, follows panenka values 1 => 4px */
  marginSM: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margins for MD devices, follows panenka values 1 => 4px */
  marginMD: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margins for LG devices, follows panenka values 1 => 4px */
  marginLG: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-top, follows panenka values 1 => 4px */
  marginTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-top for XS devices, follows panenka values 1 => 4px */
  marginTopXS: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-top for SM devices, follows panenka values 1 => 4px */
  marginTopSM: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-top for MD devices, follows panenka values 1 => 4px */
  marginTopMD: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-top for LG devices, follows panenka values 1 => 4px */
  marginTopLG: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-bottom for All devices, follows panenka values 1 => 4px */
  marginBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-bottom for XS devices, follows panenka values 1 => 4px */
  marginBottomXS: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-bottom for SM devices, follows panenka values 1 => 4px */
  marginBottomSM: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-bottom for MD devices, follows panenka values 1 => 4px */
  marginBottomMD: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-bottom for LG devices, follows panenka values 1 => 4px */
  marginBottomLG: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-left for all devices, follows panenka values 1 => 4px */
  marginLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-left for XS devices, follows panenka values 1 => 4px */
  marginLeftXS: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-left for SM devices, follows panenka values 1 => 4px */
  marginLeftSM: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-left for MD devices, follows panenka values 1 => 4px */
  marginLeftMD: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-left for LG devices, follows panenka values 1 => 4px */
  marginLeftLG: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-right for all devices, follows panenka values 1 => 4px */
  marginRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-right for XS devices, follows panenka values 1 => 4px */
  marginRightXS: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-right for SM devices, follows panenka values 1 => 4px */
  marginRightSM: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-right for MD devices, follows panenka values 1 => 4px */
  marginRightMD: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin-right for LG devices, follows panenka values 1 => 4px */
  marginRightLG: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css margin for all devices, follows panenka values 1 => 4px */
  padding: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding for XS devices, follows panenka values 1 => 4px */
  paddingXS: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding for SM devices, follows panenka values 1 => 4px */
  paddingSM: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding for MD devices, follows panenka values 1 => 4px */
  paddingMD: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding for LG devices, follows panenka values 1 => 4px */
  paddingLG: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-top for all devices, follows panenka values 1 => 4px */
  paddingTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-top for XS devices, follows panenka values 1 => 4px */
  paddingTopXS: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-top for SM devices, follows panenka values 1 => 4px */
  paddingTopSM: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-top for MD devices, follows panenka values 1 => 4px */
  paddingTopMD: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-top for LG devices, follows panenka values 1 => 4px */
  paddingTopLG: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-bottom for all devices, follows panenka values 1 => 4px */
  paddingBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-bottom for XS devices, follows panenka values 1 => 4px */
  paddingBottomXS: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-bottom for SM devices, follows panenka values 1 => 4px */
  paddingBottomSM: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-bottom for MD devices, follows panenka values 1 => 4px */
  paddingBottomMD: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-bottom for LG devices, follows panenka values 1 => 4px */
  paddingBottomLG: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-left for all devices, follows panenka values 1 => 4px */
  paddingLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-left for XS devices, follows panenka values 1 => 4px */
  paddingLeftXS: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-left for SM devices, follows panenka values 1 => 4px */
  paddingLeftSM: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-left for MD devices, follows panenka values 1 => 4px */
  paddingLeftMD: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-left for LG devices, follows panenka values 1 => 4px */
  paddingLeftLG: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-right for all devices, follows panenka values 1 => 4px */
  paddingRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-right for XS devices, follows panenka values 1 => 4px */
  paddingRightXS: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-right for SM devices, follows panenka values 1 => 4px */
  paddingRightSM: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-right for MD devices, follows panenka values 1 => 4px */
  paddingRightMD: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css padding-right for LG devices, follows panenka values 1 => 4px */
  paddingRightLG: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css width for all devices, follows css values */
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css width for XS devices, follows css values */
  widthXS: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css width for SM devices, follows css values */
  widthSM: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css width for MD devices, follows css values */
  widthMD: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css width for LG devices, follows css values */
  widthLG: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css height for all devices, follows css values */
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css height for XS devices, follows css values */
  heightXS: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css height for SM devices, follows css values */
  heightSM: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css height for MD devices, follows css values */
  heightMD: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** css height for LG devices, follows css values */
  heightLG: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};